<template>
  <div class="component-wrap gradation-gray" v-if="dataList && dataList.length">
    <div class="analysis-title-box">
      <h3 class="analysis-title analysis-title-channel">많이 본 인물</h3>
    </div>
    <div class="mypooq-swiper-container my-component02" id="swiper-container02">
      <ul class="mypooq-swiper-wrapper">
        <li class="mypooq-swiper-slide" v-for="(data, index) in dataList" :key="index" >
          <a href="" @click.prevent="()=>searchByKeyword(data)">
            <span class="thumb-text-wrap">
              <span class="thumb-text-right">
                <strong class="thumb-title-two">{{data.persionname}}</strong>
                <span class="thumb-text01">{{data.viewcount}}편</span>
              </span>
            </span>
          </a>
        </li>
      </ul>
      <span class="scrollbar-none"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true
    },
    device: {
      type: String
    }
  },
  data () {
    return {}
  },
  methods: {
    searchByKeyword (data) {
      if (this.device === 'mobile') {
        this.$router.push(`/search?searchWord=${data.persionname}&searchCategory=all&bt=n`)
      } else {
        location.href = 'captvpooq://search?keyword=' + encodeURIComponent(data.persionname)
      }
    }
  }
}
</script>

<style lang="css">
  .mypooq-swiper-container{
    position: relative;
    width: 100%;
    display: flex;
  }
  .my-component02{
    padding: 10px 0
  }
  .my-component02 .mypooq-swiper-wrapper{
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
    padding: 0 10px 10px;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .mypooq-swiper-wrapper::-webkit-scrollbar{
    display: none;
    background-color: transparent;
  }
  .mypooq-swiper-wrapper::-webkit-scrollbar-thumb {
    display: none;
    background-color: transparent;
  }

  .my-component02 .scrollbar-none{
    display: block;
    content: '';
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 8px;
    z-index: 2;
    background-color: #1b1b1b;
  }

  .mypooq-swiper-slide{
    flex: 0 0 auto;
  }
  .analysis-title-channel{
    color: #fff;
  }

  .thumb-text-wrap {
    display: table;
    width: 100%;
    padding-top: 7px;
    table-layout: fixed;
  }
  .component-wrap{
    width: 100%;
    height: auto;
  }
  .no-pooq + .component-wrap{
    border-top: 0;
  }
  .thumb-text-left, .thumb-text-right {
    display: block !important;
    vertical-align: middle !important;
  }
  .thumb-title-one, .thumb-title-two {
    font-size: 13px;
    color: #a5a5a5;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .thumb-title-two {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
  }
  .my-component03 .thumb-title-two{
    font-weight: 400;
  }
  .thumb-text01 {
    font-size: 12px;
    color: #a5a5a5;
    line-height: 15px;
    display: block;
    margin-top: 2px;
  }
  .my-component02 .mypooq-swiper-slide{
    width: 100px;
    margin-left: 10px;
    text-align: center;
  }
  .my-component02 .mypooq-swiper-slide:first-child{
    margin-left: 0;
  }
  .my-component02 .thumb-text-wrap{
    display: table;
    width: 100px;
    height: 100px;
    padding: 0 20px;
    border: 1px #3887ff solid;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
  }
  .my-component02 .thumb-text-wrap .thumb-text-right{
    display: table-cell !important;
  }
  .my-component02 .thumb-title-two{
    color: #3887ff;
  }
  .my-component02 .thumb-text01{
    margin-top: 0;
    font-size: 12px;
    color: #3887ff;
  }
</style>
